/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { action, computed } from '@ember/object';
import { filter } from '@ember/object/computed';
import Component from '@ember/component';
import { isBlank } from '@ember/utils';

@tagName('')
export default class Previewer extends Component {
  isHeaderPanelExpanded = false;
  isViewingMobile = false;

  @filter('preview.headers.@each.name', (header) => {
    return !isBlank(header.name);
  })
  validHeaders;

  @computed('validHeaders', 'preview.{reply_to,bcc}')
  get headerCount() {
    let count = this.get('validHeaders.length') || 0;

    if (this.get('preview.reply_to')) {
      count++;
    }
    if (this.get('preview.bcc')) {
      count++;
    }
    return count;
  }

  @action
  toggleHeaderPanel() {
    this.toggleProperty('isHeaderPanelExpanded');
  }

  @action
  toggleViewingMobile(isViewing) {
    this.set('isViewingMobile', isViewing);
  }
}
